export var EColumnBusinessType;
(function (EColumnBusinessType) {
    EColumnBusinessType["None"] = "NONE";
    EColumnBusinessType["AmountLocal"] = "Amount(##LOCAL##)";
    EColumnBusinessType["AmountReport"] = "Amount(##REPORT##)";
    EColumnBusinessType["AmountRow"] = "Amount(##ROW##)";
    EColumnBusinessType["AmountPairCCY1"] = "Amount(##PAIR_CCY1##)";
    EColumnBusinessType["AmountPairCCY2"] = "Amount(##PAIR_CCY2##)";
    EColumnBusinessType["Id"] = "Id";
    EColumnBusinessType["Percentage"] = "percentage";
    EColumnBusinessType["BasisPoint"] = "basisPoints";
})(EColumnBusinessType || (EColumnBusinessType = {}));
